// Tiny client-side ULID generator (Crockford base32, 26 chars). Used as the
// idempotency token for a bet/DFS-entry submit: it fits the backend's String(26)
// transaction_id columns (unlike crypto.randomUUID(), which is 36 chars), and a
// double-click / network-retry that reuses the same token collapses to one
// charge + one bet/ticket. Math.random is fine here — this is a uniqueness token,
// not a security secret.
const ENC = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'   // Crockford base32 (no I L O U)

export function newUlid(): string {
  let ts = Date.now()
  let time = ''
  for (let i = 0; i < 10; i++) {           // 48-bit ms timestamp -> 10 base32 chars
    time = ENC[ts % 32] + time
    ts = Math.floor(ts / 32)
  }
  let rand = ''
  for (let i = 0; i < 16; i++) {           // 80 bits of randomness -> 16 chars
    rand += ENC[Math.floor(Math.random() * 32)]
  }
  return time + rand
}
